module.exports = __webpack_public_path__ + "img/cover-1@2x.ea2e8620.png";